import React from 'react'
import { Link } from 'react-router-dom'
import { LabDataHandler } from 'utils'
import defaultLabImage from 'assets/img/default/default-lab.png'


const LabTitle = ({ lab, history }) => {
	const id = LabDataHandler.getLabID(lab);

	return (
		<div id='dashboard-title' className='dashboard-title h-100'>
			<span
				className={`${(!lab || !lab.avatar) ? 'opacity-80' : ''}
						dashboard-title-pic img-circle`}
				onClick={() => history.push(`/lab/dashboard/${id}`)}
				style={{ backgroundImage: `url(${(lab && lab.avatar) ? lab.avatar.url
						: defaultLabImage})` }}
			/>

			<span className='dashboard-title-text txt-normal'>
				{lab ? lab.title : ''}
			</span>

			{(lab && lab.category === 0)
				?
				<Link className='add-btn' to={`/lab/my-lab/setting/${lab.id}`}>
					<i className='fas fa-plus' />
				</Link>
				:
				null}
		</div>
	);
}


export { LabTitle }
